import { Check, Copy } from "lucide-react";
import { useState } from "react";
import { useIntl } from "react-intl";
import { Button } from "./Button.js";
import styles from "./CopyField.module.css";

/** Einmal angezeigter Wert (Einladungslink, Kopplungscode) mit Kopierknopf – nur in der Verwaltung. */
export function CopyField({ label, value, large }: { label: string; value: string; large?: boolean }) {
  const intl = useIntl();
  const [copied, setCopied] = useState(false);
  return (
    <div className={styles.field}>
      <span className={styles.label}>{label}</span>
      <div className={styles.row}>
        <output className={large ? styles.large : styles.value} dir="ltr">
          {value}
        </output>
        <Button
          variant="secondary"
          icon={copied ? <Check /> : <Copy />}
          onPress={() => {
            void navigator.clipboard?.writeText(value).then(() => setCopied(true));
          }}
        >
          {intl.formatMessage({ id: copied ? "common.copied" : "common.copy" })}
        </Button>
      </div>
    </div>
  );
}
